import { deflateSync, inflateSync } from 'fflate';

import { MapTypes } from '@23degrees/shared-code/config/constants';
import { roundTo } from '@23degrees/shared-code/utilities';

import { Content } from '@23degrees/shared-code/models';

export const compressMapData = (content: Content): void => {
  if (!MapTypes.includes(content.type)) return;

  const { map } = content.typeSpecific;

  let dataSize = 0;
  let compressedSize = 0;

  // filter all sources that could contain geojson data
  const geoSources = map.customSources.filter((source) => source.type === 'geojson');
  for (const source of geoSources) {
    // do we need to compress this?
    if (source.data?.features.length > 0) {
      try {
        const dataStr = JSON.stringify(source.data);
        const dataBuffer = new TextEncoder().encode(dataStr);
        const compressedBuffer = deflateSync(dataBuffer, { level: 7 });

        source.compressedData = Array.from(compressedBuffer);
        source.data = { type: 'FeatureCollection', features: [] };

        dataSize += dataBuffer.length;
        compressedSize += compressedBuffer.length;
      } catch (error) {
        source.data = { type: 'FeatureCollection', features: [] };
        delete source.compressedData;

        console.log('[compressMapData] error', error);
      }
    }
  }

  // do we need to compress custom markers?
  if (map.annotations.custom?.markers.features.length > 0) {
    try {
      const dataStr = JSON.stringify(map.annotations.custom.markers);
      const dataBuffer = new TextEncoder().encode(dataStr);
      const compressedBuffer = deflateSync(dataBuffer, { level: 7 });

      map.annotations.custom.compressedMarkers = Array.from(compressedBuffer);
      map.annotations.custom.markers = { type: 'FeatureCollection', features: [] };

      dataSize += dataBuffer.length;
      compressedSize += compressedBuffer.length;
    } catch (error) {
      map.annotations.custom.markers = { type: 'FeatureCollection', features: [] };
      delete map.annotations.custom.compressedMarkers;

      console.log('[compressMapData] error', error);
    }
  }

  console.log('[compressMapData]', `reduced size by ${roundTo(100 - (compressedSize / dataSize) * 100)}%`);
};

export const decompressMapData = (content: Content): void => {
  if (!MapTypes.includes(content.type)) return;

  const { map } = content.typeSpecific;

  // filter all sources that could contain geojson data
  const geoSources = map.customSources.filter((source) => source.type === 'geojson');
  for (const source of geoSources) {
    // do we need to decompress this?
    if (source.compressedData) {
      try {
        const decompressedBuffer = inflateSync(new Uint8Array(source.compressedData));
        const dataStr = new TextDecoder().decode(decompressedBuffer);
        const data = JSON.parse(dataStr);

        source.data = data;
        delete source.compressedData;
      } catch (error) {
        source.data = { type: 'FeatureCollection', features: [] };
        delete source.compressedData;

        console.log('[decompressMapData] error', error);
      }
    }
  }

  // do we need to decompress this?
  if (map.annotations.custom.compressedMarkers) {
    try {
      const decompressedBuffer = inflateSync(new Uint8Array(map.annotations.custom.compressedMarkers));
      const markersStr = new TextDecoder().decode(decompressedBuffer);
      const markers = JSON.parse(markersStr);

      map.annotations.custom.markers = markers;
      delete map.annotations.custom.compressedMarkers;
    } catch (error) {
      map.annotations.custom.markers = { type: 'FeatureCollection', features: [] };
      delete map.annotations.custom.compressedMarkers;

      console.log('[decompressMapData] error', error);
    }
  }
};
